
if (!window.mpcState) {
    window.mpcState = window.createTwoWayBindings({
        isInStorePickup: false,
        selectedShippingType: null,
        selectedZipCode: "",
        selectedShipDate: "",
        selectedShipMethodCode: "",
        requireShipDate: true,
        overrideEnableCheckout: false,
        disabledPaymentText: "You must select a ship or pickup date to continue to checkout."
    });
}

(function (global) {
    const NS = "MPCShipping";
    if (global[NS]) return; // don't redefine

    const host = "https://mpc-shipping-euaz.onrender.com";

    let initialized = false;
    let currentTimeInTransitData = [];
    let selectedShippingMethod = null;
    let fp = null;
    let zipTouched = false;
    const timeInTransitCache = {};
    let restrictedDates = [];

    let zipInput,
        zipSubmitBtn,
        shippingTypeSelect,
        shippingTypeSubmitBtn,
        shipDatePickerInput,
        zipBlock,
        shipDateBlock,
        shippingTypeBlock,
        pickupInStoreCb,
        backToZipBtn,
        backToShippingTypeBtn;

    function init() {
        if (!global.showShipDateSelection) {
            window.mpcState.requireShipDate = false;
            return;

        };

        if (Array.isArray(mpcSettings.restrictedShipDates)) {
            restrictedDates = mpcSettings.restrictedShipDates
                .map((item) => {
                    const dateStr = item?.date || "";
                    const parsed = parseDateStr(dateStr);
                    return {
                        month: parsed.month,
                        day: parsed.day,
                        year: parsed.year,
                        allowIsp: Boolean(item?.allowIsp),
                    };
                })
                .filter((x) => x.month && x.day);
        } else {
            // fallback 
            restrictedDates = (global.restrictedDatesStr || "")
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
                .map((dateStr) => {
                    const parsed = parseDateStr(dateStr);
                    return {
                        month: parsed.month,
                        day: parsed.day,
                        year: parsed.year,
                        allowIsp: false
                    };
                });
        }


        // Resolve elements
        zipInput = document.getElementById("zip-input");
        zipSubmitBtn = document.getElementById("zip-submit");
        shippingTypeSelect = document.getElementById("shipping-type-select");
        shippingTypeSubmitBtn = document.getElementById("shipping-type-select-submit");
        shipDatePickerInput = document.getElementById("ship-date-picker");
        zipBlock = document.getElementById("zip-block");
        shipDateBlock = document.getElementById("ship-date-block");
        shippingTypeBlock = document.getElementById("shipping-type-selection-block");
        pickupInStoreCb = document.getElementById("pickup-in-store-cb");
        backToZipBtn = document.getElementById("back-to-zip-entry");
        backToShippingTypeBtn = document.getElementById("back-to-shipping-type-select");

        // Initial view
        showBlock(zipBlock, "forward");

        // Form guard
        const cart = document.getElementById("cart");
        if (cart) {
            cart.onsubmit = function (e) {
                if (!mpcState.selectedShipDate && !mpcState.overrideEnableCheckout && mpcState.requireShipDate) {
                    alert(`You must select a ${mpcState.isInStorePickup ? "pickup" : "ship"} date to proceed`);
                    e.preventDefault();
                    return false;
                }
                return true;
            };
        }

        // Events
        pickupInStoreCb?.addEventListener("change", function () {
            mpcState.isInStorePickup = this.checked;
            mpcState.selectedShipDate = "";
            if (this.checked) {
                global.mpcState.selectedShipMethodCode = "ISP";
                toggleZipError(false);
                showBlock(shipDateBlock, "forward");
                bindCalendar(false);
                return;
            }
            showBlock(zipBlock);
            global.mpcState.selectedShipMethodCode = "";

            if (!zipTouched) return;
            const value = zipInput.value.trim();
            toggleZipError(!isValidZip(value));
        });

        zipInput?.addEventListener("input", function () {
            if (!zipTouched) return;
            if (pickupInStoreCb.checked) return;
            const value = zipInput.value.trim();
            toggleZipError(!isValidZip(value));
        });

        zipInput?.addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
                event.preventDefault();
                zipSubmitBtn.click();
            }
        });

        zipSubmitBtn?.addEventListener("click", async function () {
            zipTouched = true;
            const zip = zipInput.value.trim();
            if (!isValidZip(zip)) {
                toggleZipError(true);
                return;
            }

            loading(this, true);
            currentTimeInTransitData = await getTimeInTransitByZip(zip);

            if (!Array.isArray(currentTimeInTransitData) || currentTimeInTransitData.length === 0) {
                alert("No shipping options available for the provided zip code.");
                loading(this, false);

                mpcState.requireShipDate = false;
                return;
            }

            // Populate select menu
            shippingTypeSelect.innerHTML = "";
            currentTimeInTransitData.forEach((service) => {
                const option = document.createElement("option");
                option.textContent = service.serviceType;
                option.value = service.serviceCode;
                shippingTypeSelect.appendChild(option);
            });

            mpcState.selectedZipCode = zip;
            showBlock(shippingTypeBlock, "forward");
            loading(this, false);
        });

        shippingTypeSubmitBtn?.addEventListener("click", function () {
            const selectedCode = shippingTypeSelect.value;
            global.mpcState.selectedShipMethodCode = selectedCode;
            selectedShippingMethod = currentTimeInTransitData.find((s) => s.serviceCode === selectedCode);
            global.mpcState.selectedShippingType = selectedShippingMethod?.serviceType || null;
            bindCalendar(true);
            showBlock(shipDateBlock, "forward");
        });

        backToZipBtn?.addEventListener("click", () => {
            showBlock(zipBlock, "back");
            mpcState.selectedShipDate = "";
        });

        backToShippingTypeBtn?.addEventListener("click", () => {
            showBlock(shippingTypeBlock, "back");
            mpcState.selectedShipDate = "";
        });

        initialized = true;
    }

    // ------- Calendar -------
    function bindCalendar(presetDate) {
        if (fp) fp.destroy();

        fp = global.flatpickr(shipDatePickerInput, {
            disableMobile: true,
            monthSelectorType: "static",
            minDate: new Date(),
            maxDate: new Date().fp_incr(60),
            locale: { firstDayOfWeek: 0 },
            dateFormat: "m / d / Y",
            onReady: async (_sel, _str, instance) => {
                await setDisabledDates(instance);
                if (presetDate) {
                    setFirstAvailableDate(instance);
                }else{
                    instance.setDate(null);
                }
            },
            onMonthChange: async (_sel, _str, instance) => {
                await setDisabledDates(instance);
            },
            onYearChange: async (_sel, _str, instance) => {
                await setDisabledDates(instance);
            },
            onChange: (_sel, dateStr) => {
                mpcState.selectedShipDate = dateStr;
            },
        });
    }

    async function setDisabledDates(instance) {
        const disabledDates = [];
        const transitDays = selectedShippingMethod?.daysInTransit || 0;

        const nowUTC = new Date();
        const nowCT = new Date(nowUTC.toLocaleString("en-US", { timeZone: "America/Chicago" }));

        const todayCT = new Date(nowCT);
        todayCT.setHours(0, 0, 0, 0);

        const tomorrowCT = new Date(todayCT);
        tomorrowCT.setDate(todayCT.getDate() + 1);

        for (let i = 0; i <= 60; i++) {
            const shipDate = new Date(todayCT);
            shipDate.setDate(todayCT.getDate() + i);
            shipDate.setHours(0, 0, 0, 0);

            const dayOfWeek = shipDate.getDay();
            const month = shipDate.getMonth() + 1;
            const day = shipDate.getDate();
            const year = shipDate.getFullYear();

            // Block static days
            const staticRestrictedDaysOfWeek = [0, 6];
            if (!mpcState.isInStorePickup) staticRestrictedDaysOfWeek.push(5);
            if (staticRestrictedDaysOfWeek.includes(dayOfWeek)) {
                disabledDates.push(shipDate);
                continue;
            }

            // Always disable today
            if (shipDate.getTime() === todayCT.getTime()) {
                disabledDates.push(shipDate);
                continue;
            }

            // Custom restricted dates
            const matchingRestricted = restrictedDates.find(
                (rd) =>
                    parseInt(rd.day, 10) === day &&
                    parseInt(rd.month, 10) === month &&
                    (!rd.year || parseInt(rd.year, 10) === year)
            );

            if (matchingRestricted) {
                if (!(mpcState.isInStorePickup && matchingRestricted.allowIsp)) {
                    disabledDates.push(shipDate);
                    continue;
                }
            }

            // Weekend delivery rule
            if (!mpcState.isInStorePickup && deliveryCrossesOrLandsOnWeekend(shipDate, transitDays)) {
                disabledDates.push(shipDate);
                continue;
            }

            // Tomorrow cutoff logic (12 PM CT)
            if (shipDate.getTime() === tomorrowCT.getTime()) {
                const cutoffTimeCT = new Date(todayCT);
                cutoffTimeCT.setHours(12, 0, 0, 0);
                if (nowCT > cutoffTimeCT) {
                    disabledDates.push(shipDate);
                    continue;
                }
            }
        }

        instance.set("disable", disabledDates);
    }

    function setFirstAvailableDate(instance) {
        const today = new Date();
        for (let i = 0; i < 60; i++) {
            const candidate = new Date(today);
            candidate.setDate(today.getDate() + i);
            if (instance.isEnabled(candidate)) {
                instance.setDate(candidate, true);
                break;
            }
        }
    }

    // ------- Data -------
    async function getTimeInTransitByZip(zipCode) {
        if (!zipCode) return [];
        if (timeInTransitCache[zipCode]) return timeInTransitCache[zipCode];

        try {
            const res = await fetch(`${host}/ups?zipCode=${encodeURIComponent(zipCode)}`);
            const data = await res.json();
            timeInTransitCache[zipCode] = data;
            return data;
        } catch (err) {
            console.error("Error fetching UPS data:", err);
            return [];
        }
    }

    // ------- Utils -------
    function parseDateStr(dateStr) {
        const [month, day, year] = (dateStr || "").split("/");
        return { month, day, year: year || null };
    }

    function deliveryCrossesOrLandsOnWeekend(startDate, businessDays) {
        const date = new Date(startDate);
        let skippedWeekend = false;

        while (businessDays > 0) {
            date.setDate(date.getDate() + 1);
            const day = date.getDay();
            if (day === 0 || day === 6) {
                skippedWeekend = true;
            } else {
                businessDays--;
            }
        }

        const landsOnWeekend = [0, 6].includes(date.getDay());
        return skippedWeekend || landsOnWeekend;
    }

    function loading(elem, isLoading) {
        if (!elem) return false;

        const spinnerClass = "inline-spinner";
        if (typeof isLoading === "undefined") {
            return elem.classList.contains("loading-active");
        }

        if (isLoading) {
            if (!elem.classList.contains("loading-active")) {
                elem.dataset.originalText = elem.textContent;
                elem.textContent = "";

                const spinner = document.createElement("span");
                spinner.className = spinnerClass;
                spinner.innerHTML = '<span class="spinner-rotator"></span>';

                elem.appendChild(spinner);
                elem.classList.add("loading-active");
                elem.disabled = true;
            }
        } else {
            if (elem.classList.contains("loading-active")) {
                elem.textContent = elem.dataset.originalText || "Submit";
                delete elem.dataset.originalText;
                elem.classList.remove("loading-active");
                elem.disabled = false;
            }
        }
    }

    function showBlock(showEl, direction = "forward") {
        const blocks = document.querySelectorAll(".block-section");

        blocks.forEach((el) => {
            el.classList.remove("active", "direction-forward", "direction-back");
            el.style.display = "none";
        });

        if (!showEl) return;

        showEl.style.display = "block";
        showEl.classList.add(direction === "back" ? "direction-back" : "direction-forward");

        void showEl.offsetWidth;

        showEl.classList.add("active");
    }

    function toggleZipError(show) {
        const el = document.getElementById("zip-error");
        if (el) el.classList.toggle("visible", !!show);
    }

    function isValidZip(zip) {
        if (!zip || typeof zip !== "string") return false;
        const trimmedZip = zip.trim();
        return /^\d{5}(-\d{4})?$/.test(trimmedZip);
    }

    // Expose API
    global[NS] = { init };
})(window);

// window.MPCShipping.init();


(function () {
    const _fetch = window.fetch;
    window.fetch = async (...args) => {
        const res = await _fetch(...args);
        try {
            const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
            if (url && /\/cart\/(add|change|update)/.test(url)) {
                setTimeout(function () {
                    document.dispatchEvent(new CustomEvent('cart:updated'));
                }, 0);
            }
        } catch { }
        return res;
    };
})();
